(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rl-curtain"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rl-curtain')) {
    customElements.define('rl-curtain', class extends HTMLElement {
      connectedCallback() {
        this.handle = this.querySelector('.rlc-handle');
        if (!this.handle) return;
        this.p = 50;
        this.side = 'b';
        this.delay = (parseFloat(this.dataset.interval) || 4) * 1000;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.onMove = this.onMove.bind(this);
        this.onUp = this.onUp.bind(this);
        this.handle.addEventListener('pointerdown', (e) => {
          e.preventDefault();
          this.dragging = true;
          this.stop();
          this.classList.add('is-dragging');
          window.addEventListener('pointermove', this.onMove);
          window.addEventListener('pointerup', this.onUp);
          window.addEventListener('pointercancel', this.onUp);
        });
        this.handle.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.show('a'); this.start(); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.show('b'); this.start(); }
        });
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting;
            if (this.visible) { this.start(true); } else { this.stop(); }
          }, { threshold: 0.35 });
          this.io.observe(this);
        }
      }
      disconnectedCallback() { this.stop(); if (this.io) this.io.disconnect(); }
      start(first) {
        this.stop();
        if (this.reduce || window.matchMedia('(max-width: 749px)').matches) return;
        if (first && this.p === 50) {
          this.kick = setTimeout(() => this.next(), 900);
        }
        this.timer = setInterval(() => this.next(), this.delay);
      }
      stop() { clearInterval(this.timer); clearTimeout(this.kick); }
      next() { if (!this.dragging) this.show(this.side === 'a' ? 'b' : 'a'); }
      show(side) { this.side = side; this.set(side === 'a' ? 97 : 3); }
      set(p) {
        this.p = Math.max(0, Math.min(100, p));
        this.style.setProperty('--p', this.p + '%');
        this.classList.toggle('is-a', this.p > 62);
        this.classList.toggle('is-b', this.p < 38);
        this.handle.setAttribute('aria-valuenow', Math.round(this.p));
      }
      onMove(e) {
        if (!this.dragging) return;
        const r = this.getBoundingClientRect();
        this.set(((e.clientX - r.left) / r.width) * 100);
      }
      onUp() {
        this.dragging = false;
        this.classList.remove('is-dragging');
        window.removeEventListener('pointermove', this.onMove);
        window.removeEventListener('pointerup', this.onUp);
        window.removeEventListener('pointercancel', this.onUp);
        this.show(this.p >= 50 ? 'a' : 'b');
        if (this.visible !== false) this.start();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-image-with-text"] && !Shopify.designMode) return;
  try {
    
  class StickyImageWithText extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('.sticky-image-with-text__media');
      this.mediaCol = this.querySelector('.sticky-image-with-text__media-col');
      if (!this.media || !this.mediaCol) return;

      this.updateStickyPosition = this.updateStickyPosition.bind(this);
      this.updateStickyPosition();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.updateStickyPosition);
        this.resizeObserver.observe(this.media);
      }

      window.addEventListener('resize', this.updateStickyPosition, { passive: true });
      window.addEventListener('load', this.updateStickyPosition, { once: true });
    }

    updateStickyPosition() {
      const mediaHeight = this.media?.getBoundingClientRect().height || 0;
      if (mediaHeight <= 0) return;

      this.style.setProperty('--sticky-media-height', `${mediaHeight}px`);

      const topOffset = Math.max(0, (window.innerHeight - mediaHeight) / 2);
      this.mediaCol.style.setProperty('--top-custom', `${Math.round(topOffset)}px`);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.updateStickyPosition);
    }
  }

  if (!customElements.get('sticky-image-with-text')) {
    customElements.define('sticky-image-with-text', StickyImageWithText);
  }

  } catch(e) { console.error(e); }
})();
})();
